export default "__VITE_ASSET__ccCc2Yjn__"